<template>
    <modal name="auth-app" transition="pop-out" :width="modalWidth" :height="400" :clickToClose="false">
        <div class="box" v-if="app">
            <div id="bp-left">
                <div v-if="app.strategy === 'initst'" class="partition" id="partition-register">
                    <div class="partition-title">Authorize Integration</div>
                    <p>Confirm your Initial State password to authorize this integration.</p>

                    <div class="form">
                        <form autocomplete="false">
                            <input type="text" v-model="user.email" disabled="true">
                            <input type="password" v-model="data.password" placeholder="Password">

                            <div class="separator"></div>

                            <div v-if="appAuthorizationStatus.error">
                                <div v-if="appAuthorizationStatus.errorType === 'AUTH_LOCKOUT'">
                                    You're doing that too much, try again later.
                                </div>
                                <div v-else>
                                    Hmmm... try again.
                                </div>
                            </div>

                            <div class="button-set">
                                <button class="outline-btn authorize call-to-action" @click="authorize" :disabled="appAuthorizationStatus.loading">Authorize <spinner v-if="appAuthorizationStatus.loading" hideText="true"></spinner></button>
                                <button class="outline-btn cancel visible-xs visible-sm" @click="cancel">Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div v-else class="partition" id="partition-register">
                    <div class="partition-title">Authorize Integration</div>
                    <p>Enter your {{ app.name }} login information to authorize this integration.</p>

                    <div class="form">
                        <form autocomplete="false">
                            <input type="text" v-model="data.username" placeholder="Username/Email">
                            <input type="password" v-model="data.password" placeholder="Password">

                            <div class="separator"></div>

                            <div v-if="appAuthorizationStatus.error">
                                Hmmm... try again.
                            </div>

                            <div class="button-set">
                                <button class="outline-btn authorize call-to-action" @click="authorize" :disabled="appAuthorizationStatus.loading">Authorize <spinner v-if="appAuthorizationStatus.loading" hideText="true"></spinner></button>
                                <button class="outline-btn cancel visible-xs visible-sm" @click="cancel">Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
    import { mapGetters } from 'vuex';
	import Spinner from '../components/Spinner';    

    const MODAL_WIDTH = 656;
    export default {
        name: 'AuthAppModal',
        data () {
            return {
                modalWidth: MODAL_WIDTH,
                data: {}
            };
        },
        components: {
			Spinner,
        },
        computed: {
			...mapGetters([
				'appIdentity',
				'app',
                'appAuthorizationStatus',
                'selectedItem',
				'user'
			])
        },
        watch: {
			appAuthorizationStatus(status, prev) {
                if (!status) {
                    return;
                }

                if (status.error) {
                    this.resetForm();
                } else if (status.success) {
                    this.resetForm();
                    this.close();
                }
			},
		},
        methods: {
            authorize: function() {
                let data = {
                    ...this.data
                };
                if (this.app.strategy === 'initst') {
                    data.username = this.user.email;
                }
                this.$store.dispatch('START_APP_AUTH_POST', { strategy: this.app.strategy, appId: this.app.id, data, itemId: this.selectedItem.id });
            },
            cancel: function() {
			    this.close();
                this.$store.dispatch('RESET_APP_AUTH_STATUS');
            },
            close: function() {
			    this.$modal.hide('auth-app');
            },
            resetForm: function() {
                this.data = {};
            }
        },
        created () {
            this.modalWidth = window.innerWidth < MODAL_WIDTH
            ? MODAL_WIDTH / 2
            : MODAL_WIDTH;
        }
    };
</script>
<style>
    .box {
        background: white;
        overflow: hidden;
        width: 656px;
        height: 400px;
        border-radius: 2px;
        box-sizing: border-box;
        box-shadow: 0 0 40px black;
        color: #8b8c8d;
        /* font-size: 0; */
    }
    .box .box-part {
        display: inline-block;
        position: relative;
        vertical-align: top;
        box-sizing: border-box;
        height: 100%;
        width: 50%;
    }
    .box .box-messages {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
    }
    .box .box-error-message {
        position: relative;
        overflow: hidden;
        box-sizing: border-box;
        height: 0;
        line-height: 32px;
        padding: 0 12px;
        text-align: center;
        width: 100%;
        font-size: 11px;
        color: white;
        background: #F38181;
    }
    .box .partition {
        width: 100%;
        height: 100%;
    }
    .box .partition .partition-title {
        box-sizing: border-box;
        padding: 30px;
        width: 100%;
        text-align: center;
        letter-spacing: 1px;
        font-size: 20px;
        font-weight: 300;
    }
    .box .partition p {
        text-align: center;
        font-size: 12px;
    }
    .box .partition .form {
        text-align: center;
        padding: 0 20px;
        box-sizing: border-box;
    }
    .box input[type=password], .box input[type=text] {
        display: block;
        box-sizing: border-box;
        margin: auto;
        margin-bottom: 4px;
        width: 50%;
        font-size: 12px;
        line-height: 2;
        border: 0;
        border-bottom: 1px solid #DDDEDF;
        padding: 4px 8px;
        font-family: inherit;
        transition: 0.5s all;
        outline: none;
    }
    .box button {
        background: white;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 10px;
        letter-spacing: 1px;
        font-family: "Open Sans", sans-serif;
        font-weight: 400;
        min-width: 140px;
        margin-top: 8px;
        color: #8b8c8d;
        cursor: pointer;
        border: 1px solid #DDDEDF;
        text-transform: uppercase;
        transition: 0.1s all;
        font-size: 10px;
        outline: none;
    }
    .box button:hover {
        border-color: #c7c8c9;
        color: #6f7071;
    }
    .box .large-btn {
        width: 100%;
        background: white;
    }
    .box .large-btn span {
        font-weight: 600;
    }
    .box .large-btn:hover {
        color: white !important;
    }
    .box .button-set {
        margin-bottom: 8px;
    }
    .box .separator {
        margin-top: 42px;
    }
    .pop-out-enter-active, .pop-out-leave-active {
        transition: all 0.5s;
    }
    .pop-out-enter, .pop-out-leave-active {
        opacity: 0;
        transform: translateY(24px);
    }
    button.cancel:hover {
        background-color: #DDDEDF;
    }
    button.authorize {
        margin-left: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/AuthAppModal.vue